import { TableRow } from '@shared/UI';
import { IServiceTransfersDto } from '@shared/api';

interface IOptions {
    onPaymentRequestViewClick: (id: IServiceTransfersDto) => void;
}

export function getPaymentRequestTableRows(options: IOptions): TableRow<IServiceTransfersDto> {
    const { onPaymentRequestViewClick } = options;
    return { onClick: (row) => () => onPaymentRequestViewClick(row) };
}
